import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropFootprintByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP } from "consts";

export const useGetFootprintingCropFootprintByPrimaryDataId = (primaryDataId?: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP, primaryDataId, isAdmin],
      // TODO: Add the service function for public fetching crop footprint by PDID
      queryFn: () => getFootprintingCropFootprintByPrimaryDataIdAdmin(primaryDataId ?? ""),
      enabled: enabled && isAdmin && !!primaryDataId,
      gcTime: 60000,
      staleTime: 0,
      refetchOnMount: "always",
    },
    queryClient
  );
};
